export enum LambdaName {
    PRE_PROCESSED_SCENE_DATA = 'kartivappUpdatePreProcessedSceneData',
}
